import React from 'react';

const NeonBackground = () => {
  return (
    <div className="fixed inset-0 w-full h-full bg-neon-bg" style={{ zIndex: -10 }}>
      {/* Líneas de grid neon */}
      <div className="absolute inset-0 opacity-20" 
        style={{
          backgroundImage: `
            linear-gradient(0deg, transparent 24%, theme('colors.neon.blue') 25%, theme('colors.neon.blue') 26%, transparent 27%, transparent 74%, theme('colors.neon.blue') 75%, theme('colors.neon.blue') 76%, transparent 77%, transparent),
            linear-gradient(90deg, transparent 24%, theme('colors.neon.blue') 25%, theme('colors.neon.blue') 26%, transparent 27%, transparent 74%, theme('colors.neon.blue') 75%, theme('colors.neon.blue') 76%, transparent 77%, transparent)
          `,
          backgroundSize: '50px 50px'
        }}
      />
      
      {/* Círculos neon aleatorios */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full bg-neon-purple/10 blur-2xl"></div>
      <div className="absolute top-3/4 left-2/3 w-40 h-40 rounded-full bg-neon-pink/10 blur-2xl"></div>
      <div className="absolute top-1/2 left-1/3 w-24 h-24 rounded-full bg-neon-blue/10 blur-2xl"></div>
      <div className="absolute top-1/3 left-2/3 w-36 h-36 rounded-full bg-neon-green/10 blur-2xl"></div>
      
      {/* Líneas horizontales neon que se desvanecen */}
      <div className="absolute top-1/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-blue to-transparent opacity-50"></div>
      <div className="absolute top-2/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-pink to-transparent opacity-50"></div>
      <div className="absolute top-3/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-green to-transparent opacity-50"></div>
    </div>
  );
};

export default NeonBackground; 